<template>
  <v-card color="parishonline">
    <v-card-title style="color: #CBDDD7">Subscribe Now</v-card-title>
    <v-card-subtitle style="color: #CBDDD7">Includes 10% Discount</v-card-subtitle>
    <v-divider></v-divider>
    <v-card-text style="background-color: #036546; color: #CBDDD7; padding: 8px 8px 8px 24px;">
      For new subscribers to Parish Online who want to get started straight away with no trial period.
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text style="background-color: #036546; color: #CBDDD7; padding: 8px 8px 8px 24px;">
      We'll give you this discount every year providing you keep a continuous subscription with Parish Online.
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-row no-gutters justify="end">
        <v-btn rounded outlined
               color="#CBDDD7"
               @click="handleSelect()"
        >
          <span class="pr-1">Select</span>
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: "SubscriptionCard",
    components: {},
    props: {},
    data() {
      return {}
    },
    computed: {},
    methods: {
      handleSelect() {
        this.$emit('select');
      }
    }
  }
</script>
